import React from 'react';
// import { Link } from 'react-router-dom';
import { Link,useNavigate ,useLocation} from 'react-router-dom';
import { useEffect } from "react";
// import { useLocation ,useNavigate} from "react-router-dom";
import { Mail, Phone, Linkedin, Facebook, Instagram } from 'lucide-react';
import '../styles/Footer.css';

const downloadPDF = () => {
  const link = document.createElement("a");
  link.href = "/Diagnostic-Guide.pdf";   // your file path
  link.download = "Diagnostic-Guide.pdf"; // file name for user
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
const Footer = () => {
  useEffect(() => {
  if (location.state?.scrollTo) {
    const element = document.getElementById(location.state.scrollTo);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }
});
  return (
    <footer className="footer">
      <section className="cta-sectio">
            <div className="cta-containe">
               <div className="diag3-success">
    ✓ 6 out of 6 clients recovered the diagnostic investment within 4 weeks of first changes.
  </div>
              <h4>Ready to Build Systems That Last?</h4>
      
              <h2>Start with operational certainty.</h2>
              <p>
                Book a fit call to assess whether
                 the Operational Diagnostic makes sense for your business. No pressure. Just a focused conversation.
              </p>
              
            <div className="cta-buttons">
  
      
              <Link to="/contact" className="btn-2">
                Book a Fit Call
              </Link>
              <div className="download-btn" onClick={downloadPDF}>
    <span className="btn-text">↓ Download Our Diagnostic Guide</span>

    <span className="btn-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"
        />
      </svg>
    </span>
  </div>
  </div>
            </div>
          </section>

      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <h3 className="footer-logo"> FNBDATALAB</h3>
            <p className="footer-desc">
             Operating Intelligence for Food & Beverage Businesses
             </p>
             <p className="footer-desc">
            Building profitable, scalable operations — one disciplined decision at a time.

            </p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/in/rraj-fnbdatalab/" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/fnbdatalab/" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/our-services">Services</Link></li>
              <li><a href="/our-work">Our Work</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><Link to="/operationals-diagnostic">Operational Diagnostic</Link></li>
            </ul>
          </div>

          {/* <div className="footer-col">
            <h4 className="footer-heading">Our Services</h4>
            <ul className="footer-links">
              <li><a href="/cost-optimisation">Operations & Cost Optimisation</a></li>
              <li><a href="#kitchen-menu-systems">Kitchen & Menu Systems</a></li>
              <li><a href="#hiring-training">Hiring & Training Frameworks</a></li>
              <li><a href="#licensing-compliance">Licensing & Compliance</a></li>
              <li><a href="#supply-chain">Supply Chain & Vendor Systems</a></li>
              <li><a href='#technology-pos'>Technology, POS & Analytics</a></li>
              <li><a href="#digital-growth">Digital Brand & Growth</a></li>
              <li><a href="/performance-tracking">Performance Tracking</a></li>
            </ul>
          </div> */}


          <div className="footer-col">
                    <h4 className="footer-heading">Our Services</h4>
                    <ul className="footer-links">
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "cost-optimisation" }}>
                          Operations & Cost Optimisation
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "kitchen-menu-systems" }}>
                          Kitchen & Menu Systems
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "hiring-training" }}>
                          Hiring & Training Frameworks
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "licensing-compliance" }}>
                          Licensing & Compliance
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "supply-chain" }}>
                          Supply Chain & Vendor Systems
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "technology-pos" }}>
                          Technology, POS & Analytics
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "digital-growth" }}>
                          Digital Brand & Growth
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-services" state={{ scrollTo: "performance-tracking" }}>
                          Performance Tracking
                        </Link>
                      </li>
                    </ul>
                  </div>

          <div className="footer-col">
            <h4 className="footer-heading">Get In Touch</h4>
            <ul className="footer-contact">
              <li className="footer-heading">
                <Mail size={16} />
                <a href="mailto:support@fnbdatalab.com">support@fnbdatalab.com</a>
              </li>
              <li className="footer-heading">
                <Phone size={16} />
                <a href="tel:+919845810118">+91 9845810118</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 FNBDATALAB. All rights reserved.</p>
          <div className="footer-bottom-links">
                      <a
              href="/Privacy Policy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span>|</span>

            <a
              href="/Terms of Service.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
                      {/* <a href="#">Privacy Policy</a>
            <span>|</span>
            <a href="#">Terms of Service</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;